import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-khb-drawing',
  templateUrl: './khb-drawing.component.html',
  styleUrls: ['./khb-drawing.component.css']
})
export class KhbDrawingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/planning/khb-drawing/khb-drawing.component.ts